// @ts-nocheck

import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Line from './Line'
// import TokensMobile from './TokensMobile'

import TransactionsMobileList from './TransactionsMobileList'
import TransactionsPcList from './TransactionsPcList'

import { isMobile } from 'react-device-detect'
import TokensMobileList from './TokensMobileList'
import TokensPcList from './TokensPcList'
import PoolsPcList from './PoolsPcList'
import PoolsMobileList from './PoolsMobileList'

const TabContent = styled.div<{ isVisible: boolean }>`
  display: ${props => (props.isVisible ? 'block' : 'none')};
  transition: opacity 0.3s ease-in-out;
  opacity: ${props => (props.isVisible ? 1 : 0)};
`
const TabContainer = styled.span`
  &.active {
    font-weight: bold;
    color: #007bff;
  }
`
const Tab = styled.div`
  margin-top: 40px;
  display: flex;
  span {
    color: #4e5969;
    cursor: pointer;
    font-size: 20px;
    margin-right: 32px;
    font-weight: 500;
    &:hover {
      opacity: 0.6;
    }
  }
  .active {
    color: #1d2129;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    justify-content: space-evenly;
    border-bottom: 1px solid #e5e6eb;
    padding-bottom: 8px;
    margin-top: 16px;
    span {
      font-size: 16px;
      text-align: center;
      margin-right: 0;
      flex: 1;
      font-weight: 600;
      color: #4e5969;
      &:hover {
        opacity: 1;
      }
    }
    .active {
      color: #1d2129;
      position: relative;
      &::after {
        content: '';
        left: 0;
        position: absolute;
        width: 100%;
        bottom: -9px;
        height: 2px;
        background-color: #3973b4;
      }
    }
  }
`
const Page = styled.div`
  width: 1200px;
  min-height: 100vh;
  margin-top: 40px;
  font-family: 'Inter var', sans-serif;
  @media (max-width: 768px) {
    margin-top: 0px;
    width: 100%;
    background: #f7f8fa;
    padding: 16px;
    height: 100%;
    /* overflow-y: auto; */
  }
`

export default function Explore() {
  const [current, setCurrent] = useState(0)
  const tab = [
    {
      id: 0,
      text: 'Tokens'
    },
    {
      id: 1,
      text: 'Pools'
    },
    {
      id: 2,
      text: 'Transactions'
    }
  ]
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <Page>
      <Line></Line>
      <Tab>
        {tab.map(item => (
          <span key={item.id} className={`${item.id === current ? 'active' : ''}`} onClick={() => setCurrent(item.id)}>
            {item.text}
          </span>
        ))}
      </Tab>
      <div className="right"></div>

      <div style={{paddingBottom:10}}>
        {current === 0 && (isMobile ? <TokensMobileList /> : <TokensPcList />)}
        {current === 1 && (isMobile ? <PoolsMobileList /> : <PoolsPcList />)}
        {current === 2 && (isMobile ? <TransactionsMobileList /> : <TransactionsPcList />)}
      </div>
    </Page>
  )
}
